<template>
    <iframe src="https://lk-ai.top/" style="width: 100%;height: 88vh;border: none;"></iframe>
</template>